import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Google Meet brand mark. The colored segments are set per-path, so `currentColor`
// on the wrapping svg does not affect them.
var GoogleMeet = function GoogleMeet(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 87.5 72",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#00832d",
      d: "M49.5 36l8.53 9.75 11.47 7.33 2-17.02-2-16.64-11.69 6.44z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#0066da",
      d: "M0 51.5V66c0 3.315 2.685 6 6 6h14.5l3-10.96-3-9.54-9.95-3z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#e94235",
      d: "M20.5 0L0 20.5l10.55 3 9.95-3 2.95-9.41z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#2684fc",
      d: "M0 20.5h20.5v31H0z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00ac47",
      d: "M82.6 8.68L69.47 19.42v33.66l13.19 10.79c1.97 1.54 4.85.135 4.85-2.37V11c0-2.535-2.945-3.925-4.91-2.32zM49.5 36v15.5h-29V72h43c3.315 0 6-2.685 6-6V53.08z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#ffba00",
      d: "M63.5 0h-43v20.5h29V36l20-16.57V6c0-3.315-2.685-6-6-6z"
    })]
  }));
};
export default GoogleMeet;